/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const QuestCommerceBillingModel = {
    NONE: 'NONE',
    PER_REDEMPTION: 'PER_REDEMPTION',
    PERCENTAGE: 'PERCENTAGE',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY'
} as const;
export type QuestCommerceBillingModel = typeof QuestCommerceBillingModel[keyof typeof QuestCommerceBillingModel];


export function instanceOfQuestCommerceBillingModel(value: any): boolean {
    for (const key in QuestCommerceBillingModel) {
        if (Object.prototype.hasOwnProperty.call(QuestCommerceBillingModel, key)) {
            if (QuestCommerceBillingModel[key as keyof typeof QuestCommerceBillingModel] === value) {
                return true;
            }
        }
    }
    return false;
}

export function QuestCommerceBillingModelFromJSON(json: any): QuestCommerceBillingModel {
    return QuestCommerceBillingModelFromJSONTyped(json, false);
}

export function QuestCommerceBillingModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestCommerceBillingModel {
    return json as QuestCommerceBillingModel;
}

export function QuestCommerceBillingModelToJSON(value?: QuestCommerceBillingModel | null): any {
    return value as any;
}

export function QuestCommerceBillingModelToJSONTyped(value: any, ignoreDiscriminator: boolean): QuestCommerceBillingModel {
    return value as QuestCommerceBillingModel;
}

